import React, { useEffect } from 'react';

import { useAuth } from '~/hooks/auth';
import { permissions } from '~/types/constants';
import { ObjectLiteral } from '~/types/generics';

import Button from '../Button';
import {
  Container,
  SelectedContainer,
  OptionsContainer,
  SelectedNumber,
  ClearSelectionButton,
  SelectedText,
  AssignedContainer,
} from './styles';

interface ButtonOptions {
  label: string;
  icon: JSX.Element;
  action: () => void;
  permissions?: Array<permissions>;
}

interface ActionModalProps {
  selectedItemsLength: number;
  selectedUser?: ObjectLiteral;
  buttonOptions: ButtonOptions[];
  open: boolean;
  onClear: () => void;
  onSelectedItemsModalState: (open: boolean) => void;
  onOpenActionModal: (open: boolean) => void;
  selectUserText?: string;
}

const ActionModal: React.FC<ActionModalProps> = ({
  selectedItemsLength,
  selectedUser,
  buttonOptions,
  onClear,
  onSelectedItemsModalState,
  onOpenActionModal,
  open,
  selectUserText,
}) => {
  const { checkPermission } = useAuth();

  useEffect(() => {
    if (selectedItemsLength >= 1) {
      onOpenActionModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItemsLength]);

  return open ? (
    <Container>
      <SelectedContainer>
        <SelectedNumber>{selectedItemsLength}</SelectedNumber>
        <SelectedText>
          {selectedItemsLength >= 2 ? 'Selecionados' : 'Selecionado'}
        </SelectedText>
        {selectedUser && (
          <AssignedContainer>
            <p>{selectUserText}</p>
            {`${selectedUser.firstName} ${selectedUser.lastName}`}
          </AssignedContainer>
        )}
      </SelectedContainer>
      <OptionsContainer>
        <ClearSelectionButton onClick={onClear}>Cancelar</ClearSelectionButton>
        <Button
          variant="outline"
          onClick={() => onSelectedItemsModalState(true)}
        >
          Ver selecionados
        </Button>
        {buttonOptions.map(
          (button) =>
            checkPermission(button.permissions ?? []) && (
              <Button onClick={() => button.action()}>
                {button.icon}
                <span>{button.label}</span>
              </Button>
            ),
        )}
      </OptionsContainer>
    </Container>
  ) : null;
};

export default ActionModal;
